export class ImageService {
    constructor(image, imgproxyService) {
        this.image = image;
        this.imgproxyService = imgproxyService;
    }
    initializeImage() {
        // Debug point: Image initialization
        if (this.image.node.nodeName !== 'IMG' || this.image.node.getAttribute('src')) {
            return;
        }
        this.image.node.src = ImageService.TRANSPARENT_PIXEL;
    }
    loadImage() {
        // Skip if the image already has the correct URL
        if (this.imgproxyService.isSameUrl(this.image.node, this.image.config)) {
            return Promise.resolve(true);
        }
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                // Debug point: Image loaded successfully
                resolve(true);
            };
            img.onerror = () => {
                // Debug point: Image load error
                resolve(false);
            };
            img.src = this.imgproxyService.generateUrl(this.image.config);
        });
    }
    render() {
        // Skip if the image already has the correct URL
        if (this.imgproxyService.isSameUrl(this.image.node, this.image.config)) {
            return;
        }
        const url = this.imgproxyService.generateUrl(this.image.config);
        if (this.image.node.nodeName === 'IMG') {
            // Debug point: Rendering as <img> element
            this.image.node.src = url;
        }
        else {
            // Debug point: Rendering as background image
            this.image.node.style.backgroundSize = 'cover';
            this.image.node.style.backgroundPosition = 'center';
            this.image.node.style.backgroundRepeat = 'no-repeat';
            this.image.node.style.backgroundImage = `url(${url})`;
        }
    }
}
ImageService.TRANSPARENT_PIXEL = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
//# sourceMappingURL=image.service.js.map